import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto12() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.89 43.29" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path
						class="cls-1"
						d="M39.78,37.73l-7.17-.86a5.35,5.35,0,0,0-2.36-4.78l-5-3.34a6.3,6.3,0,0,1-1.95-2.06l-.35-.59a10.82,10.82,0,0,0-8.5-5.32l.77-1.15A.83.83,0,0,0,15,18.47h0L9.47,14.8A.84.84,0,0,0,8.31,15h0l-8,12.08A.83.83,0,0,0,.5,28.27h0L6,31.94H6a.84.84,0,0,0,1.14-.24l.38-.58,2,.13a2.94,2.94,0,0,1,2,1l7.16,7.88s0,0,0,0a10.15,10.15,0,0,0,1.79,1.4,11.14,11.14,0,0,0,4.47,1.61.48.48,0,0,0,.12,0l17.71-.25a.82.82,0,0,0,.82-.79A4.2,4.2,0,0,0,39.78,37.73ZM2.12,27.35l7.12-10.7,4.11,2.75L6.23,30.09Zm23,14.15A9.44,9.44,0,0,1,19.86,39l-7.15-7.86A4.6,4.6,0,0,0,9.6,29.6l-1-.07,4.73-7.11A9.18,9.18,0,0,1,21.5,27l.35.59a8,8,0,0,0,2.45,2.6l5,3.34a3.67,3.67,0,0,1,1.39,4.32l-7.48-5a.82.82,0,0,0-1.15.23.82.82,0,0,0,.23,1.15l8.25,5.5h0a.84.84,0,0,0,1.14-.24,5.89,5.89,0,0,0,.51-1l7.35.87h0a2.53,2.53,0,0,1,2.23,1.87Z"
					/>
					<path
						class="cls-1"
						d="M29.3,5.36l7.16,1a5.3,5.3,0,0,0,2.27,4.82l5,3.43a6.48,6.48,0,0,1,1.91,2.09l.34.6a10.81,10.81,0,0,0,8.4,5.47l-.79,1.14a.82.82,0,0,0,.21,1.16h0l5.44,3.76a.82.82,0,0,0,1.16-.21h0l8.26-11.93a.84.84,0,0,0-.21-1.16h0L63,11.75h0a.82.82,0,0,0-1.14.23l-.4.57-1.94-.17a3,3,0,0,1-2-1l-7-8,0,0a11.4,11.4,0,0,0-1.76-1.42A11,11,0,0,0,44.23.2h-.12L26.4.13a.82.82,0,0,0-.83.78A4.2,4.2,0,0,0,29.3,5.36ZM66.77,16.41,59.46,27l-4.07-2.82L62.7,13.6ZM44.05,1.86a9.44,9.44,0,0,1,5.19,2.61l7,8A4.61,4.61,0,0,0,59.33,14l1,.09-4.86,7a9.16,9.16,0,0,1-8.07-4.67l-.34-.6a8.12,8.12,0,0,0-2.41-2.64l-5-3.43a3.68,3.68,0,0,1-1.32-4.34l7.39,5.11a.83.83,0,0,0,1.16-.21.82.82,0,0,0-.21-1.16L38.54,3.56l0,0a.84.84,0,0,0-1.14.23,5.5,5.5,0,0,0-.53.95l-7.34-1h0A2.55,2.55,0,0,1,27.3,1.8Z"
					/>
					<path d="M41.5,17.65h0a1.26,1.26,0,0,1,.93.41,1.27,1.27,0,0,1-.08,1.79l-8.1,7.59a1.23,1.23,0,0,1-.86.34,1.28,1.28,0,0,1-.87-.34L28,23.23,28,23.18A1.27,1.27,0,0,1,28.86,21a1.28,1.28,0,0,1,.89.36l3.64,3.41L40.62,18a1.3,1.3,0,0,1,.88-.35m0-1.8a3,3,0,0,0-2.13.86l-6,5.6L31,20.06a3.06,3.06,0,0,0-4.3.07,3.07,3.07,0,0,0,0,4.33l.1.09,4.48,4.2a3.06,3.06,0,0,0,4.19,0l8.1-7.58a3.07,3.07,0,0,0-2.07-5.32Z" />
				</g>
			</g>
		</svg>
	);
}
